<template>
  <div v-show="isActive">
    <slot
      :hasWarning="hasWarning"
      :setWarning="setWarning"
      :shouldShowWarning="shouldShowWarning"
      :resetShouldShowWarning="() => { shouldShowWarning = false; }"
    ></slot>
  </div>
</template>
<script>

export default {
  name: 'Tab',
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    className: {
      type: Array,
      default: () => [],
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tabTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
      hasWarning: false,
      shouldShowWarning: false,
      title: this.tabTitle,
    };
  },
  watch: {
    selected(newVal) {
      this.isActive = newVal;
    },
  },
  mounted() {
    this.isActive = this.selected;
    this.title = this.tabTitle;
  },
  methods: {
    setWarning(value = true) {
      this.hasWarning = value;
    },
  },
};
</script>
